import { sectionRoutes } from '../helpers';

export const TELEPHONY_ROUTES = sectionRoutes({
  meta: { adminTab: 'Telephony' },
  tabKey: 'telephonyTab',
  routes: [
    ['telephony', 'AdminTelephony', 'phone_numbers'],
    ['telephony/phone-numbers', 'AdminTelephonyPhoneNumbers', 'phone_numbers'],
  ],
});
